// Mock data for Cairo International Scripts Festival

export const hero = {
  en: {
    tagline: "Where Stories from Cairo Meet the World",
    subtitle: "Celebrating the Art of Screenwriting, Television, and Theatre",
    ctaPrimary: "Submit Your Script",
    ctaSecondary: "About the Festival"
  },
  ar: {
    tagline: "حيث تلتقي قصص القاهرة بالعالم",
    subtitle: "احتفاءً بفن كتابة السيناريو والتلفزيون والمسرح",
    ctaPrimary: "قدّم سيناريوك",
    ctaSecondary: "عن المهرجان"
  }
};

export const about = {
  en: {
    title: "About the Festival",
    vision: "Cairo International Scripts Festival celebrates original voices and exceptional storytelling from the Arab world and beyond.",
    mission: "We are dedicated to discovering, developing, and championing screenwriters, television writers, and playwrights who push the boundaries of narrative excellence.",
    focus: [
      { title: "Script Development", desc: "Professional mentorship and guidance for emerging writers" },
      { title: "Original Storytelling", desc: "Celebrating authentic voices and innovative narratives" },
      { title: "Cultural Exchange", desc: "Building bridges between Arab and international storytellers" }
    ]
  },
  ar: {
    title: "عن المهرجان",
    vision: "مهرجان القاهرة الدولي للسيناريو يحتفي بالأصوات الأصيلة والحكايات الاستثنائية من العالم العربي وخارجه.",
    mission: "نحن ملتزمون باكتشاف وتطوير ودعم كتّاب السيناريو والتلفزيون والمسرح الذين يدفعون حدود التميز السردي.",
    focus: [
      { title: "تطوير السيناريو", desc: "توجيه ودعم احترافي للكتّاب الناشئين" },
      { title: "الحكايات الأصيلة", desc: "احتفاء بالأصوات الحقيقية والسرديات المبتكرة" },
      { title: "التبادل الثقافي", desc: "بناء جسور بين رواة القصص العرب والعالميين" }
    ]
  }
};

export const program = {
  en: {
    title: "Festival Program",
    items: [
      {
        id: 1,
        title: "Script Competition",
        desc: "International competition for feature films, short films, TV series, and theatrical works",
        image: "https://images.unsplash.com/photo-1514306191717-452ec28c7814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzY5NDgxNjQzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        title: "Workshops & Labs",
        desc: "Intensive writing workshops led by industry professionals and award-winning writers",
        image: "https://images.unsplash.com/photo-1766867257943-0665537fb2dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx3b3Jrc2hvcCUyMG1lbnRvcnNoaXB8ZW58MHx8fHwxNzY5NDgxNjkzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        title: "Industry Talks",
        desc: "Panels and discussions with leading producers, directors, and industry executives",
        image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0cmFpbmluZ3xlbnwwfHx8fDE3Njk0ODE2OTl8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        title: "Script Readings",
        desc: "Live performances of selected scripts by professional actors",
        image: "https://images.unsplash.com/photo-1615414015111-8d98cb65677e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzY5NDgxNjQzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 5,
        title: "Mentorship Programs",
        desc: "One-on-one guidance from established writers and industry mentors",
        image: "https://images.unsplash.com/photo-1758522276267-b3472583e954?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3b3Jrc2hvcCUyMG1lbnRvcnNoaXB8ZW58MHx8fHwxNzY5NDgxNjkzfDA&ixlib=rb-4.1.0&q=85"
      }
    ]
  },
  ar: {
    title: "برنامج المهرجان",
    items: [
      {
        id: 1,
        title: "مسابقة السيناريو",
        desc: "مسابقة دولية للأفلام الطويلة والقصيرة والمسلسلات التلفزيونية والأعمال المسرحية",
        image: "https://images.unsplash.com/photo-1514306191717-452ec28c7814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzY5NDgxNjQzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        title: "ورش العمل والمختبرات",
        desc: "ورش كتابة مكثفة يقودها محترفو الصناعة وكتّاب حائزون على جوائز",
        image: "https://images.unsplash.com/photo-1766867257943-0665537fb2dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx3b3Jrc2hvcCUyMG1lbnRvcnNoaXB8ZW58MHx8fHwxNzY5NDgxNjkzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        title: "حوارات الصناعة",
        desc: "ندوات ونقاشات مع كبار المنتجين والمخرجين وقياديي الصناعة",
        image: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0cmFpbmluZ3xlbnwwfHx8fDE3Njk0ODE2OTl8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        title: "قراءات السيناريو",
        desc: "عروض حية للسيناريوهات المختارة يؤديها ممثلون محترفون",
        image: "https://images.unsplash.com/photo-1615414015111-8d98cb65677e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHx0aGVhdHJlJTIwc3RhZ2V8ZW58MHx8fHwxNzY5NDgxNjQzfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 5,
        title: "برامج الإرشاد",
        desc: "توجيه فردي من كتّاب راسخين ومرشدي الصناعة",
        image: "https://images.unsplash.com/photo-1758522276267-b3472583e954?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3b3Jrc2hvcCUyMG1lbnRvcnNoaXB8ZW58MHx8fHwxNzY5NDgxNjkzfDA&ixlib=rb-4.1.0&q=85"
      }
    ]
  }
};

export const submissions = {
  en: {
    title: "Submissions",
    subtitle: "Submit your original script to Cairo International Scripts Festival",
    categories: [
      { id: 1, name: "Feature Film", desc: "Full-length feature screenplays (80+ pages)" },
      { id: 2, name: "Short Film", desc: "Short film scripts (up to 40 pages)" },
      { id: 3, name: "TV / Series", desc: "Television pilots and series (any format)" },
      { id: 4, name: "Theatre / Stage", desc: "Theatrical and stage plays" }
    ],
    deadlines: [
      { type: "Early Bird", date: "March 15, 2026", fee: "$25" },
      { type: "Regular", date: "May 30, 2026", fee: "$40" },
      { type: "Late", date: "July 15, 2026", fee: "$60" }
    ],
    ctaButton: "Submit Your Script"
  },
  ar: {
    title: "التقديم",
    subtitle: "قدّم سيناريوك الأصلي إلى مهرجان القاهرة الدولي للسيناريو",
    categories: [
      { id: 1, name: "فيلم طويل", desc: "سيناريو فيلم طويل (أكثر من 80 صفحة)" },
      { id: 2, name: "فيلم قصير", desc: "سيناريو فيلم قصير (حتى 40 صفحة)" },
      { id: 3, name: "تلفزيون / مسلسل", desc: "حلقات تلفزيونية ومسلسلات (أي صيغة)" },
      { id: 4, name: "مسرح / خشبة", desc: "مسرحيات ونصوص خشبة المسرح" }
    ],
    deadlines: [
      { type: "مبكر", date: "15 مارس 2026", fee: "25$" },
      { type: "عادي", date: "30 مايو 2026", fee: "40$" },
      { type: "متأخر", date: "15 يوليو 2026", fee: "60$" }
    ],
    ctaButton: "قدّم سيناريوك"
  }
};

export const jury = {
  en: {
    title: "Jury & Mentors",
    subtitle: "Meet our distinguished panel of industry professionals",
    members: [
      {
        id: 1,
        name: "Ahmed Hassan",
        title: "Award-Winning Screenwriter",
        bio: "Two-time Oscar nominee with over 20 years of experience in international cinema.",
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        name: "Layla Mansour",
        title: "TV Producer & Showrunner",
        bio: "Creator of multiple award-winning television series across the MENA region.",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        name: "Sofia Martinez",
        title: "Theatrical Playwright",
        bio: "Internationally acclaimed playwright with works performed in 25 countries.",
        image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        name: "David Thompson",
        title: "Film Director & Script Consultant",
        bio: "Cannes-awarded director specializing in character-driven narratives.",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 5,
        name: "Youssef Ibrahim",
        title: "Creative Producer",
        bio: "Veteran producer championing emerging voices in Arab cinema.",
        image: "https://images.unsplash.com/photo-1656313836297-0cd072f08f43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc2OTQ4MTczMnww&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 6,
        name: "Nadia El-Sayed",
        title: "Script Development Executive",
        bio: "Leading script consultant for major international film festivals.",
        image: "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc2OTQ4MTczMnww&ixlib=rb-4.1.0&q=85"
      }
    ]
  },
  ar: {
    title: "لجنة التحكيم والمرشدون",
    subtitle: "تعرّف على فريقنا المتميز من محترفي الصناعة",
    members: [
      {
        id: 1,
        name: "أحمد حسن",
        title: "كاتب سيناريو حائز على جوائز",
        bio: "مرشح لجائزة الأوسكار مرتين مع أكثر من 20 عامًا من الخبرة في السينما الدولية.",
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        name: "ليلى منصور",
        title: "منتجة تلفزيونية ومديرة عروض",
        bio: "مبتكرة العديد من المسلسلات التلفزيونية الحائزة على جوائز في منطقة الشرق الأوسط وشمال إفريقيا.",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        name: "صوفيا مارتينيز",
        title: "كاتبة مسرحية",
        bio: "كاتبة مسرحية ذات شهرة عالمية عُرضت أعمالها في 25 دولة.",
        image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        name: "ديفيد طومسون",
        title: "مخرج سينمائي ومستشار سيناريو",
        bio: "مخرج حائز على جائزة من مهرجان كان متخصص في السرديات المبنية على الشخصيات.",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3Njk0ODE3MjF8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 5,
        name: "يوسف إبراهيم",
        title: "منتج إبداعي",
        bio: "منتج محنك يدعم الأصوات الناشئة في السينما العربية.",
        image: "https://images.unsplash.com/photo-1656313836297-0cd072f08f43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc2OTQ4MTczMnww&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 6,
        name: "نادية السيد",
        title: "مديرة تطوير السيناريو",
        bio: "مستشارة سيناريو رائدة للمهرجانات السينمائية الدولية الكبرى.",
        image: "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc2OTQ4MTczMnww&ixlib=rb-4.1.0&q=85"
      }
    ]
  }
};

export const partners = {
  en: {
    title: "Partners & Supporters",
    subtitle: "Proudly supported by leading cultural institutions and industry partners"
  },
  ar: {
    title: "الشركاء والداعمون",
    subtitle: "بدعم فخور من المؤسسات الثقافية الرائدة وشركاء الصناعة"
  }
};

export const contact = {
  en: {
    title: "Contact Us",
    subtitle: "Get in touch with the Cairo International Scripts Festival team",
    email: "contact@cisf.online",
    website: "cisf.online",
    location: "Cairo, Egypt",
    formLabels: {
      name: "Full Name",
      email: "Email Address",
      subject: "Subject",
      message: "Message",
      submit: "Send Message"
    }
  },
  ar: {
    title: "تواصل معنا",
    subtitle: "تواصل مع فريق مهرجان القاهرة الدولي للسيناريو",
    email: "contact@cisf.online",
    website: "cisf.online",
    location: "القاهرة، مصر",
    formLabels: {
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "الرسالة",
      submit: "إرسال الرسالة"
    }
  }
};

export const footer = {
  en: {
    tagline: "Celebrating the Art of Screenwriting",
    rights: "© 2026 Cairo International Scripts Festival. All rights reserved.",
    newsletter: {
      title: "Stay Updated",
      placeholder: "Enter your email",
      button: "Subscribe"
    },
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      linkedin: "LinkedIn"
    }
  },
  ar: {
    tagline: "احتفاءً بفن كتابة السيناريو",
    rights: "© 2026 مهرجان القاهرة الدولي للسيناريو. جميع الحقوق محفوظة.",
    newsletter: {
      title: "ابقَ على اطلاع",
      placeholder: "أدخل بريدك الإلكتروني",
      button: "اشترك"
    },
    social: {
      facebook: "فيسبوك",
      twitter: "تويتر",
      instagram: "إنستغرام",
      linkedin: "لينكد إن"
    }
  }
};

export const nav = {
  en: {
    home: "Home",
    about: "About",
    program: "Program",
    submissions: "Submissions",
    jury: "Jury",
    partners: "Partners",
    contact: "Contact"
  },
  ar: {
    home: "الرئيسية",
    about: "عن المهرجان",
    program: "البرنامج",
    submissions: "التقديم",
    jury: "لجنة التحكيم",
    partners: "الشركاء",
    contact: "اتصل بنا"
  }
};